<script>
import { mapState, mapMutations } from "vuex";
import { filter, get, orderBy, groupBy } from "lodash";
import Tile from '@/components/tile.vue';
import {ADDON_GROUP, BASE_PLAN_SUB_TYPES, BILLING_CYCLE, planTypes} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import logo from '@/assets/plans/zoom_one_pro_addon.svg';
import { DEFAULT_MEETING_PLAN_CAPACITY, PARENT_TYPES_ZOOM_MEETING_ADDON_FOR, isZoomMeetingAsAddonCard, DEFAULT_MEETING_BIZ_PLAN_CAPACITY, isBizPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import LearnMoreDialog from '@/components/learn-more-dialog/index.vue'

const def2biz = isBizPlusContext;

export default {
  name: 'ZoomMeetingAddOnCard',
  mixins: [base],
  components: {
    Tile,
    LearnMoreDialog
  },
  group(){
    return isBizPlusContext ? ADDON_GROUP.BIZ_PLUS : undefined;
  },
  for(){
    if(isBizPlusContext) return planTypes.map([planTypes.ZOOM_ONE_BUNDLE]);
    return isZoomMeetingAsAddonCard() ? planTypes.map(PARENT_TYPES_ZOOM_MEETING_ADDON_FOR): [];
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    // 
    this.$root.$on('trigger-add-zoom-one', () => this.$emit('add'));
  }, 
  data() {
    return {
      logo,
      title: def2biz ? this.$t('billing.planform.title.zoom_one_biz') : this.$t('billing.planform.title.zoom_one_pro'),
      subtitle: '',
      planType: planTypes.ZOOM_MEETING,
      description: this.$t('billing.zoom_one_pro.desc'),
      form: def2biz ? DEFAULT_MEETING_BIZ_PLAN_CAPACITY : DEFAULT_MEETING_PLAN_CAPACITY,
      promo: isBizPlusContext ? this.$t('billing.zone.promo_bizplus') : null,
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(filter(this.planMapFlat, (p) => p.type === planTypes.ZOOM_MEETING && (def2biz ? (p.category === BASE_PLAN_SUB_TYPES.BIZ) : true) && !p.isOneMonth), ['participants', 'amount'], 'asc')
      return get(list, [0], {});
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    showLearnMore() {
      return this.$context.is.buyTrial === true && !def2biz
    },
    priceInfo() {
      const result = {
        monthlyUnit: 'billing.common.per_billing_cycle_user.monthly',
        annualUnit: 'billing.common.per_billing_cycle_user.annual',
        formattedMonthlyAmount: '',
        formattedAnnualAmount: ''
      }
      const plans = this.zonePlanGroupByCategory[this.form.category]
      plans?.forEach((plan) => {
        if (plan.billing_cycle === BILLING_CYCLE.MONTHLY) {
          result.formattedMonthlyAmount = this.$money(plan.amount)
        } else if (plan.billing_cycle === BILLING_CYCLE.ANNUAL) {
          result.formattedAnnualAmount = this.$money(plan.amount)
        }
      })
      return result
    },
    learnMoreConfig() {
      return {
        videoOptions: {
          posterPath: require('@/assets/plans/addonBackground/zone.png'),
          videoSrc: "https://www.youtube.com/watch?v=Gp_Q6XrNWSU",
          isOnlineVideo: true
        },
        icon: logo,
        title: this.$t('billing.planform.title.zoom_one_pro'),
        featuresTip: this.$t('billing.zone.learn_more_modal.feature_tip'),
        introList: [{
          label: this.$t('billing.zone.learn_more_modal.intro1'),
        }, {
          label: this.$t('billing.zone.learn_more_modal.intro2'),
        }, {
          label: this.$t('billing.zone.learn_more_modal.intro3'),
        }, {
          label: this.$t('billing.zone.learn_more_modal.intro4'),
        }],
        priceInfo: this.priceInfo,
        buttonText: 'billing.common.add',
        purchaseUnit: 'add_ons.unit.user'
      }
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber,
        },
      });
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction('add-ons', `${this.title?.toLowerCase()} - add`);
      this.$nextTick(this.focusToConfig);
    },
    mx_desc() {
      return <div class="opc-addon__description first-capitalize">
        {this.description}
        {this.showLearnMore && 
          <div class="opc-addon__desc-btn-wrapper" style="margin-top: -5px">
            <zm-button type="link" onClick={this.showLearnMoreModal} aria-label={`Learn more about ${this.title}`}>
              {this.$t('common.learnMore')}
            </zm-button>
            <LearnMoreDialog 
              visible={this.dialogVisible} 
              onUpdateVisible={(value) => this.dialogVisible = value} 
              onAdd={(evt) => {this.addOn(evt); this.dialogVisible = false}}
              config={this.learnMoreConfig} 
            />
          </div> 
        }
      </div>;
    },
    showLearnMoreModal() {
      this.dialogVisible = true
    },
  }
};
</script>
